import React from 'react';
import {connect} from "react-redux";
import {scrollToStepAction} from "../../../redux/flow-reducer";
import Contact from "./Contact";
import {handleChangeAction, setReportIdAction, setResponseMessageAction} from "../../../redux/userdata-reducer";
import {sendData} from "../../../Api/Api";

class ContactContainer extends React.Component {

    constructor(props) {
        super(props);
        this.compile = this.compile.bind(this);
    }

    compile = () => {

        if(this.props.userData.reportId || this.props.userData.responseMessage){
            return false;
        }

        let array = {
            location: this.props.userData.location,
            team:this.props.team.staff,
            type:this.props.flow.variety,
            targetID:this.props.flow.targetID,
            deadline: this.props.flow.deadline_list[this.props.flow.deadline],
            userName:this.props.userData.userName,
            userMail:this.props.userData.userMail,
            userPhone:this.props.userData.userPhone,
            userMessage:this.props.userData.userMessage,
        };

        window.setTimeout(()=>{
            sendData(array).then(data => {
                if(data.json_file){
                    this.props.setReportId(data.json_file)
                }

                if (data.message){
                    this.props.setResponseMessage(data.message)
                }
            });
        }, 2000);

    };

    componentDidMount() {
        this.props.scrollToStep(7);
    }

    render() {
        return <Contact {...this.props} compile={this.compile} />
    }

}

const mapStateToProps = state => {
    return {
        flow:state.flow,
        team:state.team,
        userData:state.userData
    };
};

const mapDispatchToProps = dispatch => {
    return {
        scrollToStep: (stepId)  => {dispatch(scrollToStepAction(stepId));},
        handleChange: (event, data)  => {dispatch(handleChangeAction(event, data));},
        setReportId: (Id)  => {dispatch(setReportIdAction(Id));},
        setResponseMessage: (message)  => {dispatch(setResponseMessageAction(message));}
    };

};

export default connect(mapStateToProps, mapDispatchToProps)(ContactContainer);